import React, {useEffect, useState} from 'react';
import Axios from "axios";
import InfoList from "../../components/InfoList";
import Header from '../../components/Header';
import { FaChalkboardTeacher, FaDiagnoses, FaGraduationCap, FaLaptop, FaNewspaper, FaSchool, FaUserGraduate } from 'react-icons/fa';
import { PInfoCateList } from './PInfoCateList';
import HomeIcons from '../../components/HomeIcons';

const Home = ()=>{
    const [pageData,setPageData]=useState({
        tjInfos:[],
        ksInfos:[],
        pInfoCates:[],
        ksZlInfos:[],
        aopengInfos:[],
        yjsInfos:[],
    });
    const loadData=async ()=>{
        let res = await Axios.get('/api/home/index');
        setPageData(res.data);
    }
    useEffect(() => {
        loadData();
    },[])


    return (
        <div>
            <HomeIcons/>
            <Header title='推荐信息' HeaderIcon={FaNewspaper} />
            <div>
                <InfoList list={pageData.tjInfos}/>
            </div>

            <div className='mt-2'>
                <Header title='培训信息' to='/blist/15' HeaderIcon={FaGraduationCap} />
                <div>
                    <InfoList list={pageData.ksInfos}  />
                </div>
            </div>
            <div className='mt-2'>
                <Header title='培训课程' HeaderIcon={FaChalkboardTeacher} />
                <div>
                    <PInfoCateList cates={pageData.pInfoCates} />
                </div>
            </div>
            <div className='mt-2'>
                <Header title='考试专栏' HeaderIcon={FaDiagnoses} to='/blist/17' />
                <div>
                    <InfoList list={pageData.ksZlInfos} />
                </div>
            </div>
            <div className='mt-2'>
                <Header title='奥鹏远程学历教育专栏' HeaderIcon={FaLaptop} to='/list/65'/>
                <div>
                    <InfoList list={pageData.aopengInfos} />
                </div>
            </div>
            

        </div>
    )
}
export  default  Home;